// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagWarning-module__tag___jbj4i"};